export default __webpack_public_path__ + "static/hero-video-desktop-629cefbeba79d2871a7c0c61b0e65795.mp4";